import { render, staticRenderFns } from "./SimpleTabs.vue?vue&type=template&id=0685836e&scoped=true&"
import script from "./SimpleTabs.vue?vue&type=script&lang=ts&"
export * from "./SimpleTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleTabs.vue?vue&type=style&index=0&id=0685836e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0685836e",
  null
  
)

export default component.exports